<template>
  <div class="analytics">
    <div class="audit-global-range">
      <global-range @change="getPeriod()" />
    </div>

    <div class="sex" v-if="active">
      <div class="sex__item">
        <thema />
        <tonal />
      </div>
      <div class="sex__item">
        <ul class="post-report-wrap">
          <li
            class="post-report-wrap__item"
            v-for="theme in themes.items.filter(it => it.count > 0)"
            :key="theme.title"
            @click="openReportModal(getPeriod(theme.thematic_id))"
          >
            <el-tooltip
              content="Сформировать отчет в Excel"
              placement="top"
              effect="light"
            >
              <el-link
                class="post-report-wrap__item-link"
                :underline="false"
              >
                <div class="in_link-wrap">
                  <i class="far fa-file-excel fa-4x"></i>
                  <span>Сформировать отчет по тематике {{ theme.title }}</span>
                </div>
                </el-link>
            </el-tooltip>
          </li>
        </ul>
        <div class="age__title">
          Количество публикаций: всего - <span class= "blue">{{ themes.count }}</span>, по тематикам -
          <span class= "blue">{{ summ }}</span>
          , без тематики - <span class= "blue"> {{themes.items.filter(it => it.thematic_id == 0)[0].count || 0}}</span>

        </div>
        <ul class="">
          <li
            class="age__title"
            v-for="theme in themes.items.filter(it => it.thematic_id != 0) || []"
            :key="theme.title"
          >
            <span
              >Количество публикаций по тематике {{ theme.title }} -
              <span class= "blue">{{ theme.count }}</span></span
            >
          </li>
        </ul>
      </div>
    </div>
    <el-dialog title="Формирование отчет" :visible.sync="modalReportVisible" width="380px">
      <p>Идёт формирование отчёта. Это может занять несколько минут. Пожалуйста, не покидайте страницу, пока не завершится загрузка. Отчёт сохранится в папку "Загрузки" на вашем компьютере.
      </p>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="modalReportVisible = false">ОK</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
/*audit component from tabs directory of analytics with charts*/

// components

import Thema from "./components/Thema";
import Tonal from "./components/Tonal.vue";
import GlobalRange from "../../../../../../components/auditPeriodRange/GlobalPeriodRange";
import { getReportApi} from "../../../../../../api/feeds";
    const convert = (resp) => {
    let base64String = resp.content;
    const base64Data = base64String.replace(/^data:.+;base64,/, "");
    const byteCharacters = atob(base64Data); // Decode Base64 string
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: resp.mime });
    const url = URL.createObjectURL(blob);

    // Create a link element to download the file
    const link = document.createElement("a");
    link.href = url;
    link.download = resp.filename;
    link.click();

    // Cleanup
    URL.revokeObjectURL(url);
  };

export default {
  name: "Thematics",
  data() {
    return {
      modalReportVisible: false,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  computed: {
    themes() {
      return this.$store.getters.auditData("Thematics");
    },
    summ() {
      let entries = this.themes.items ? this.themes.items.filter(it => it.thematic_id != 0) : [];
      let sum = entries.reduce(function (sum, elem) {
        return sum + Number(elem.count);
      }, 0);
      return sum;
    },
  },
  methods: {
    getPeriod(id) {
      let thread_id = this.$route.params.threadId;
      let fFrom = this.$store.getters.getGlobalMainPeriod.map((item) =>
        item.replace(" ", " ")
      )[0];
      let fTo = this.$store.getters.getGlobalMainPeriod.map((item) =>
        item.replace(" ", " ")
      )[1];
      return (this.fileDownloadLink = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/posts_excell?thread_id=${thread_id}&from=${fFrom}&to=${fTo}&filter[thematicFilter][0]=${id}&sort[type]=date&sort[order]=desc&filter[repostoption]=whatever&filter[network_id][0]=1&filter[network_id][1]=2&filter[network_id][2]=3&filter[network_id][3]=5&filter[network_id][4]=7&filter[network_id][5]=8&filter[network_id][6]=4`);
    },
    openReportModal(link) {
      console.log("here")
        this.modalReportVisible = true;
        getReportApi(link).then(resp => {
            convert(resp.data)
        });
      },
  },
  mounted() {
    this.getPeriod();
  },
  components: {
    Thema,
    Tonal,
    GlobalRange,
  },
};
</script>

<style>
.analytics {
  padding-top: 29px;
}

.audit-global-range {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 20px;
}

.sex,
.geo {
  display: flex;
}
.blue{
  color: #409EFF;
}

  @media screen and (max-width: 480px) {
      .sex, .geo {
        display: block;
      }
  }
</style>
